(function () {
  function toNumber(value) {
    if (value === undefined || value === null || value === '') return null;
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function getCurrency(fallback) {
    return fallback || document.documentElement.dataset.shopCurrency || null;
  }

  function pushEcommerceEvent(eventName, ecommerce) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ecommerce,
    });
  }

  function buildItemFromDataset(dataset, index) {
    const item = {};
    const itemId = dataset.analyticsItemId || dataset.analyticsProductId || null;
    const itemName = dataset.analyticsItemName || dataset.analyticsProductTitle || null;
    const itemBrand = dataset.analyticsBrand || null;
    const itemVariant = dataset.analyticsVariantId || null;
    const itemListName = dataset.analyticsListName || null;
    const itemCategory = dataset.analyticsItemCategory || null;
    const price = toNumber(dataset.analyticsPrice);

    if (itemId) item.item_id = String(itemId);
    if (itemName) item.item_name = itemName;
    if (itemBrand) item.item_brand = itemBrand;
    if (itemVariant) item.item_variant = String(itemVariant);
    if (itemListName) item.item_list_name = itemListName;
    if (itemCategory) item.item_category = itemCategory;
    if (price !== null) item.price = price;
    if (index !== undefined && index !== null) item.index = index;

    return item;
  }

  function trackViewItemFromProductInfo(productInfoElement) {
    if (!productInfoElement) return;

    const item = buildItemFromDataset(productInfoElement.dataset);
    if (!item.item_id && !item.item_name) return;

    const variantId = productInfoElement.dataset.analyticsVariantId || '';
    const trackedKey = [item.item_id || '', variantId, window.location.pathname].join('|');
    if (productInfoElement.dataset.analyticsViewItemTracked === trackedKey) return;

    const price = toNumber(productInfoElement.dataset.analyticsPrice);
    const currency = getCurrency(productInfoElement.dataset.analyticsCurrency);
    const ecommerce = { items: [item] };

    if (currency) ecommerce.currency = currency;
    if (price !== null) ecommerce.value = price;

    pushEcommerceEvent('view_item', ecommerce);
    productInfoElement.dataset.analyticsViewItemTracked = trackedKey;
  }

  function trackViewItemListFromGrid(gridElement) {
    if (!gridElement) return;

    const listName = gridElement.dataset.analyticsListName || '';
    const productItems = Array.from(gridElement.querySelectorAll('li[data-analytics-item-id]'))
      .map((element, idx) => {
        const item = buildItemFromDataset(element.dataset, toNumber(element.dataset.analyticsIndex) || idx + 1);
        if (listName && !item.item_list_name) item.item_list_name = listName;
        return item;
      })
      .filter((item) => item.item_id || item.item_name);

    if (!productItems.length) return;

    const signature = `${window.location.pathname}${window.location.search}|${listName}|${productItems.length}|${productItems[0].item_id || ''}`;
    if (gridElement.dataset.analyticsViewItemListTracked === signature) return;

    const ecommerce = { items: productItems };
    if (listName) ecommerce.item_list_name = listName;

    pushEcommerceEvent('view_item_list', ecommerce);
    gridElement.dataset.analyticsViewItemListTracked = signature;
  }

  function trackAddToCart(payload) {
    if (!payload || !payload.form) return;

    const formElement = payload.form;
    const productFormElement = formElement.closest('product-form');
    const dataset = productFormElement ? productFormElement.dataset : {};
    const formData = new FormData(formElement);
    const quantity = toNumber(formData.get('quantity')) || 1;
    const response = payload.response || {};

    const datasetPrice = toNumber(dataset.analyticsPrice);
    const responseLinePrice = toNumber(response.final_line_price);
    const responseUnitPrice = toNumber(response.final_price !== undefined ? response.final_price : response.price);
    const unitPrice =
      datasetPrice !== null ? datasetPrice : responseUnitPrice !== null ? responseUnitPrice / 100 : null;
    const value =
      responseLinePrice !== null ? responseLinePrice / 100 : unitPrice !== null ? unitPrice * quantity : null;

    const item = {
      item_id: String(response.product_id || dataset.analyticsProductId || response.id || formData.get('id') || ''),
      item_name: response.product_title || dataset.analyticsProductTitle || '',
      quantity,
    };

    if (dataset.analyticsBrand) item.item_brand = dataset.analyticsBrand;
    if (response.variant_title || dataset.analyticsVariantId) {
      item.item_variant = String(response.variant_title || dataset.analyticsVariantId);
    }
    if (unitPrice !== null) item.price = unitPrice;

    if (!item.item_id && !item.item_name) return;

    const ecommerce = { items: [item] };
    const currency = getCurrency(dataset.analyticsCurrency);
    if (currency) ecommerce.currency = currency;
    if (value !== null) ecommerce.value = value;

    pushEcommerceEvent('add_to_cart', ecommerce);
  }

  function initTracking() {
    trackViewItemFromProductInfo(document.querySelector("product-info[id^='MainProduct']"));
    trackViewItemListFromGrid(document.getElementById('product-grid'));
  }

  document.addEventListener('product-info:loaded', function (event) {
    const productInfoElement = event.target && event.target.closest ? event.target.closest('product-info') : null;
    trackViewItemFromProductInfo(productInfoElement);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTracking);
  } else {
    initTracking();
  }

  window.BrandpeaceAnalytics = {
    trackAddToCart,
    trackViewItemFromProductInfo,
    trackViewItemListFromGrid,
  };
})();
